<template>
    <v-app class="homepage osago-company-page osago-contact-page">
        <div class="homepage__container homepage__white">
            <v-container class="homepage__how-to-contact">
                <h1>
                    Контакты
                </h1>
                <v-flex class="under-title">
                    Мы всегда рады ответить на ваши вопросы. <br>Звоните и пишите нам!
                </v-flex>
                <v-layout wrap>
                    <v-flex xs12 sm6 md3 class="homepage__how-to-contact__item">
                        <v-flex class="homepage__how-to-contact__item__text">Горячая линия</v-flex>
                        <v-flex class="homepage__how-to-contact__item__info">8 800 201 06 43</v-flex>
                    </v-flex>
                    <v-flex xs12 sm6 md3 class="homepage__how-to-contact__item">
                        <v-flex class="homepage__how-to-contact__item__text">Электронная почта</v-flex>
                        <v-flex class="homepage__how-to-contact__item__info"><a href="mailto:mail@getpolis.ru">mail@getpolis.ru</a></v-flex>
                    </v-flex>
                    <v-flex xs12 sm6 md3 class="homepage__how-to-contact__item">
                        <v-flex class="homepage__how-to-contact__item__text">Головной офис</v-flex>
                        <v-flex class="homepage__how-to-contact__item__info">г. Ростов-на-Дону, <br>ул. Социалистическая, <br>д. 74, оф. 609</v-flex>
                    </v-flex>
                    <v-flex xs12 sm6 md3 class="homepage__how-to-contact__item">
                        <v-flex class="homepage__how-to-contact__item__text">Режим работы</v-flex>
                        <v-flex class="homepage__how-to-contact__item__info">Пн-Пт <br>с 9:00 до 21:00</v-flex>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <div class="homepage__container homepage__white homepage__mobile-grey">
            <v-container class="homepage__how-to-contact homepage__container-faq">
                <h2>Техническая поддержка</h2>
                <v-flex class="under-title" xs9 md12>
                    По любым вопросам пишите на электронную почту, или через форму. <br hidden-sm-and-down>Мы вместе сможем сделать проект лучше!
                </v-flex>
                <v-layout wrap>
                    <v-flex xs12 md5 lg4 class="homepage__how-to-contact__item">
                        <v-flex class="homepage__how-to-contact__item__text">Время работы</v-flex>
                        <v-flex class="homepage__how-to-contact__item__info">Пн-Пт с 9:00 до 21:00</v-flex>
                    </v-flex>
                    <v-flex xs12 md5 lg4 class="homepage__how-to-contact__item">
                        <v-flex class="homepage__how-to-contact__item__text">Поддержка по почте</v-flex>
                        <v-flex class="homepage__how-to-contact__item__info"><a href="mailto:mail@getpolis.ru">mail@getpolis.ru</a></v-flex>
                    </v-flex>
                    <v-flex xs12 md12 lg4 class="homepage__how-to-contact__item">
                        <a class="black-button" @click="openFeedback">Отправить сообщение</a>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <div class="homepage__container homepage__white homepage__container-map-block">
            <iframe id="mapIFrame" src="https://yandex.ru/map-widget/v1/?z=12&ol=biz&oid=238060367850&scroll=false" width="560" height="400" frameborder="0"></iframe>
        </div>
        <homepage-feedback
            :dialog="dialog"
            @closeFeedback="closeFeedback"
        />
    </v-app>
</template>
<script>
    import Vue from "vue";
    export default {
        data: () => ({
            dialog: false,
            yandexMapsSettings: {
                apiKey: Vue.GetpolisConstants.YANDEX_API,
                lang: 'ru_RU',
                coordorder: 'latlong',
                enterprise: false,
                version: '2.1'
            }
        }),

        methods: {
            openFeedback() {
                this.dialog = true
            },
            closeFeedback() {
                this.dialog = false
            }
        }
    }
</script>
<style>
    #mapIFrame{
        height: 100vh;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/OsagoContacts.vue